<nav class="navbar bg-transparent" style="margin: 0">
  <div class="container">
    <a class="navbar-brand" routerLink='/home'><img src="./../../assets/images/logo.webp" class="navbar-logo"></a>
    <div class="navbar-expand ml-auto navbar-nav">
      <div class="navbar-nav">Hair Color Finder</div>
    </div>
  </div>
</nav>
<router-outlet></router-outlet>